export * from './product.service';
export * from './product-config.service';
export * from './product-uom.service';


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/master/wm/index.ts